import { observer } from "mobx-react-lite";

import { BulkActionBar } from "@/domains/documents/components/molecules/BulkActionBar";
import type { SigningListItem } from "../types";
import type { SigningDocumentActions } from "../useSigningDocumentActions";

interface SigningBulkActionsProps {
  /** The checked containers — every one carries a `documentId` (isBulkSelectable). */
  items: SigningListItem[];
  /** The page's one instance, shared with the rows' right-click menu — whose
   *  `dialogs` the page mounts once. */
  actions: SigningDocumentActions;
  onClearSelection: () => void;
}

/**
 * The Documents page's bulk action bar over the Signing page's checked
 * containers: Share, Download, Verified and Ask Franklin. The actions are the
 * ones the rows' right-click menu offers (useSigningDocumentActions).
 */
export const SigningBulkActions = observer(function SigningBulkActions({
  items,
  actions,
  onClearSelection,
}: SigningBulkActionsProps) {
  const bound = actions.actionsFor(items, { onDone: onClearSelection });

  return (
    <BulkActionBar
      selectedCount={bound.count}
      onClearSelection={onClearSelection}
      onShare={bound.onShare}
      onDownload={bound.onDownload}
      onToggleVerified={bound.onToggleVerified}
      verifiedState={bound.verifiedState}
      onAskFranklin={bound.onAskFranklin}
    />
  );
});
